module.exports = __webpack_public_path__ + "static/media/act4.6ba01365.jpg";